const app = {
    prefix: 'killbills_merchant_app',
    endpoint: process.env.REACT_APP_API_ENDPOINT,
    locales: ['fr-FR', 'en-GB'],
};

export default app;
